import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {FormInline} from './tb_header_data'; // 引入类型

import {Connection} from "@element-plus/icons-vue";
import {useRouter} from "vue-router"; // 引入类型


export default /*@__PURE__*/_defineComponent({
  __name: 'tb_header',
  props: /*@__PURE__*/_mergeModels({
    formData: {}
  }, {
    "form-data": {},
    "form-dataModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["search"], ["update:form-data"]),
  setup(__props: any) {

const model = _useModel<FormInline>(__props, 'form-data');
// 👇 接收父组件传入的 formData

// 定义触发的事件


const changePage=()=>{
  window.open('https://starry.17xiudou.cn/h5/record/', '_blank');
}

const router = useRouter()


return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    inline: true,
    class: "demo-form-inline"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, { label: "支付日期" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_date_picker, {
            modelValue: model.value.date,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.date) = $event)),
            type: "datetimerange",
            "single-panel": ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('search')))
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("查询", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})